var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "outIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 282",
    transform: "translate(-.416)",
    fill: "#a1a1a1",
    stroke: "#707070",
    d: "M0 0h72v72H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "outIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 385",
    transform: "translate(-.416)",
    fill: "none",
    d: "M0 0h72v72H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.416)",
    clipPath: "url(#outIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "OutIcon"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 383",
    clipPath: "url(#outIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 551",
    d: "M47.297 25.128l3.174.216q-.239 1.392-.382 2.088h5.536V30.6a11.285 11.285 0 002.029 1.728v-6.936h3.2v9.216a36.275 36.275 0 004.772 2.688l-1.671 2.976a19.718 19.718 0 01-3.1-1.8v8.112h-3.2v-10.44l-1.152-.912q-.214-.191-1.384-1.2a17.853 17.853 0 01-2.744 7.272 17.8 17.8 0 01-4.028 4.06 15.355 15.355 0 01-2.434 1.508l-2.171-2.832a13.777 13.777 0 003.627-1.992 8.864 8.864 0 002.577-2.9q-.191-.24-1.1-1.536-.286-.408-1.551-1.872a20.175 20.175 0 01-1.792 2.924l-2-2.76a23.52 23.52 0 002.792-5.928 23.951 23.951 0 001-4.848m5.2 5.16h-3.1q-.43 1.416-.907 2.736a32.524 32.524 0 012.915 3.168A13.943 13.943 0 0052.239 33a22.682 22.682 0 00.264-2.712",
    fill: "#231815"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 552",
    d: "M28.66 52.844H9.038a3 3 0 010-6H28.66a7.4 7.4 0 007.276-7.5v-.906a7.4 7.4 0 00-7.276-7.5H13.307a3 3 0 010-6H28.66a13.318 13.318 0 0113.1 13.5v.906a13.319 13.319 0 01-13.1 13.5",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 553",
    d: "M8.877 30.938a2.868 2.868 0 01-2.231-1.072 3.063 3.063 0 01.359-4.226l12.677-10.96a2.851 2.851 0 014.1.37 3.064 3.064 0 01-.359 4.226l-12.677 10.96a2.849 2.849 0 01-1.869.7",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 554",
    d: "M21.551 41.898a2.847 2.847 0 01-1.869-.7L7.005 30.236a3.064 3.064 0 01-.359-4.226 2.851 2.851 0 014.1-.37L23.423 36.6a3.064 3.064 0 01.359 4.226 2.87 2.87 0 01-2.231 1.072",
    fill: "#040000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutIcon);
export default __webpack_public_path__ + "static/media/outIcon.3d2d83c797ff7c4d.svg";
export { ForwardRef as ReactComponent };